export default __webpack_public_path__ + "static/media/plain-sticker-K.b666af1c.png";